import Enum from "./enum";

class OptionWorkTitle extends Enum {
    static ENABLE = 1; // 入力させる
    static DISABLE = 9; // 入力させない

    static values() {
        return {
            [this.ENABLE]: '入力させる',
            [this.DISABLE]: '入力させない',
        }
    }
}

export default OptionWorkTitle;